import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import "./global.css";

import VueLayers from "vuelayers";
import "vuelayers/lib/style.css"; // needs css-loader
Vue.use(VueLayers);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

